<template>
  <div class="my-order movie-order" ref="moviecontainer">
    <!-- 头部 -->
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">订单信息</div>
          <!-- <div>
              累计订单：{{ orderData.order_count || 0 }}
            </div> -->
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>

    <!-- 导航头 -->
    <div class="nav acea-row row-around">

      <!-- 状态导航栏 -->
      <div class="item" v-for="(item, key) in orderStatusList" :key="key" :class="{ on: type == item.id }" @click="$router.replace(`/xkYcOrderList/${item.id}`)">
        <div>{{ item.status }}</div>
        <div class="num">{{ item.orderNum }}</div>
      </div>

    </div>

    <!-- 订单列表 -->
    <div class="list">
      <div class="item" v-for="(order, key) in orderList" :key="key">

        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            订单号：{{ order.order_id || "" }}
          </div>
          <div class="font-color-red">{{ statusText(order) }}</div>
        </div>


        <div>
          <div class="item-info movie-item">
            <div class="movie-pictrue">
              <img :src="order.dramalogo || ''" />
            </div>
            <div class="item-right">
              <div class="width-height-100 movie-title">
                <h1>{{ order.projectName || "演出名称" }}</h1>
              </div>
            </div>
          </div>

        </div>

        <!-- button -->
        <div class="bottom acea-row row-right row-middle">
          <template v-if="order.status == '1' && order.yincang == true">
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付款
            </div>
          </template>
          <template v-if="order.status == '2'">
            <div class="bnt bg-color-red3" @click="$router.push({ path: '/xuanKuaYcPayDetail/' + order.order_id })">
              查看详情
            </div>
          </template>

          <!-- <template v-if="order._status._type === 4">
              <div
                class="bnt bg-color-red"
                @click="$router.push({ path: '/order/detail/' + order.order_id })"
              >
                查看订单
              </div>
            </template> -->
        </div>
      </div>
    </div>
    <!--  -->
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue">
        <img src="@assets/images/order_Lack.png" />
        <div class="pictrue_size">暂无演出订单~</div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
    <!-- <GeneralWindow
        :generalActive="generalActive"
        @closeGeneralWindow="closeGeneralWindow"
        :generalContent="generalContent"
      ></GeneralWindow> -->
  </div>
</template>

<script>
import { getXkYcOrderList, getXkYcOrderData } from "@api/movie";
import { payXkYcOrderHandle } from "@libs/XuanKuaYc.js";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import { stringToArray } from "@utils/movie.js";
// import GeneralWindow from "@components/GeneralWindow";

const NAME = "xkYcOrderList";

export default {
  name: NAME,
  data: function () {
    return {
      orderStatusList: [ //状态导航栏
        {
          status: "全部订单",
          orderNum: 0,
          id: 3,
          name: "order_count"
        }, {
          status: "待付款",
          orderNum: 0,
          id: 1,
          name: "unpaid_count"
        }, {
          status: "已完成",
          orderNum: 0,
          id: 2,
          name: "complete_count"
        }
      ],
      offlinePayStatus: 2,
      orderData: {}, //订单信息
      type: parseInt(this.$route.params.id) || 3,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin", 'zh'],
      from: isWeixin() ? "weixin" : "weixinh5",
      // generalActive: false,
      // generalContent: {
      //     promoterNum: "",
      //     title: ""
      // }
    }
  },
  components: {
    Loading,
    Payment,
    // GeneralWindow
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.id) || 3;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getMovieOrderData();
      }
    }
  },
  mounted() {
    this.getMovieOrderData();
    this.getXkYcOrderList();
    this.$scroll(this.$refs.moviecontainer, () => {
      !this.loading && this.getXkYcOrderList();
    });
  },
  methods: {
    //旧出票状态
    statusText: function(order) {
      console.log(order);
      if (order.status == '2') { //已付款
        return order._status._title;
      }
      if (order.status == '1') {
        if (order.yincang) {
          return order._status._title;
        } else {
          return '已过期';
        }
      }
    },
    setLoca: function (val) {
      return stringToArray(val);
    },
    setOfflinePayStatus: function (status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getMovieOrderData() {
      getXkYcOrderData().then(res => {
        this.orderData = res.data;
        this.orderStatusList.forEach((item, key) => {
          item.orderNum = res.data[`${item.name}`];
        });
      });
    },
    getXkYcOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getXkYcOrderList({
        page,
        limit,
        type
      }).then(res => {
        res.data.forEach((item, key) => {
          item.yincang = true;
          item.expire_time = new Date(item.expire_time.replace(/-/g, '/')).getTime();

          let nowTime = new Date().getTime();
          let differ = parseFloat(nowTime - item.expire_time) / 1000;
          if (differ >= 0) {
            item.yincang = false;
          }
        });
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    // closeGeneralWindow(msg) {
    //   this.generalActive = msg;
    //   this.reload();
    //   this.getOrderData();
    // },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getXkYcOrderList();
    },
    paymentTap: function (order) { //立即付款
      let nowTime = new Date().getTime();
      let differ = parseFloat(nowTime - order.expire_time) / 1000;
      if (differ >= 0) {
        order.yincang = false;
        this.$dialog.error('已过期请重新下单');
        return;
      }
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        this.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.payType = [order.pay_type];
      this.toPay = type => { // 订单单号 支付方式
        let ci_id = null;
        if (order.coupon_id) ci_id = order.coupon_id;//次券id
        payXkYcOrderHandle(order.order_id, type, this.from, ci_id)
          .then(() => {
            const type = parseInt(this.$route.params.id) || 3;
            this.changeType(type);
            this.getMovieOrderData();
            this.$store.dispatch("USERINFO", true);
          })
          .catch(res => {
            if (res.status === "WECHAT_H5_PAY")
              return this.$router.push({
                path: "/order/status/" + order.order_id + "/5"
              });
            const type = parseInt(this.$route.params.id) || 3;
            this.changeType(type);
            this.getMovieOrderData();
          });
      };
    },
    toPay() { }
  },
  beforeDestroy: function () {
    this.$scroll.remove(this.$refs.moviecontainer);
  }
}
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}

.movie-pictrue {
  width: 1.8rem;
  height: 2.3rem;
  margin-right: .2rem;
}

.movie-pictrue img {
  width: 100%;
  height: 100%;
  border-radius: .2rem;
}

.movie-item {
  display: flex;
}

.movie-title {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.movie-title h1 {
  margin-bottom: .2rem;
  font-size: .3rem;
  font-weight: 600;
}

.item-right {
  flex: 1;
  position: relative;
  padding-right: .8rem;
}

.item-right .money {
  position: absolute;
  right: 0;
  top: 0;
  color: black;
  font-size: .32rem;
}

.movie-info div {
  margin-top: .1rem;
}

.my-order .nav {
  margin-top: 0rem !important;
}

.movie-info div span {
  margin-right: .1rem;
}

.pictrue_size {
  width: 100%;
  height: 2rem;
  text-align: center;
  line-height: 2rem;
}

.my-order .header {
  background: -webkit-gradient(linear, right top, left top, from(#ff0b46), to(#ffaf98)) !important;
}

.my-order .header:after {
  background: linear-gradient(-90deg, #ff0b46, #ffaf98) !important;
}
</style>